import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>
                When to Consider TekRevol's Cross Platform Application
                Development Services?
              </h2>
              <p>
                We specialize in developing dynamic cross-platform and hybrid
                apps that seamlessly combine rich features, robust
                functionality, and captivating aesthetics.
              </p>
              <p>
                Our cross platform app development service ensures flawless
                performance across a range of mobile devices, enhancing user
                experiences.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Cross Platform App
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Launching A Cross-Platform App</h6>
              <p>
                TekRevol's expertise in cross-platform development ensures that
                your app runs seamlessly on various platforms, providing a
                consistent user experience across all devices.
              </p>
            </div>
            <div className="consider-box">
              <h6>Accelerating Product Launch</h6>
              <p>
                TekRevol's cross-platform development accelerates your app's
                time-to-market, vital for businesses striving to swiftly launch
                products and maintain a competitive edge in dynamic markets.
              </p>
            </div>
            <div className="consider-box">
              <h6>Cost-Effective App Development</h6>
              <p>
                We provide cost-effective cross platform app development
                services, maintaining competitive prices while ensuring
                top-notch quality, and delivering affordability in the market.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
